import { useState } from "react";
import { Camera } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { photoUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const ProjectDialog = ({ item, onClose }) => {
  const [idx, setIdx] = useState(0);
  if (!item) return null;
  const i = Math.min(idx, item.photos.length - 1);
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { setIdx(0); onClose(); } }}>
      <DialogContent className="max-w-2xl" data-testid="project-dialog">
        <DialogHeader>
          <DialogTitle data-testid="project-dialog-title">{item.title}</DialogTitle>
          <DialogDescription>{item.student_first_name} · {item.school_name} · {item.program}</DialogDescription>
        </DialogHeader>
        <img src={photoUrl(item.photos[i])} alt={item.title} className="w-full max-h-[60vh] object-contain rounded-xl bg-white" data-testid="project-dialog-photo" />
        {item.photos.length > 1 && (
          <div className="flex gap-2">
            {item.photos.map((p, j) => (
              <button key={p} onClick={() => setIdx(j)} data-testid={`project-dialog-thumb-${j}`} className={`w-16 h-16 rounded-lg overflow-hidden border-2 ${j === i ? "border-[#FF2E63]" : "border-transparent"}`}>
                <img src={photoUrl(p)} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        )}
        {item.description && <p className="text-sm text-[#0A192F] whitespace-pre-line" data-testid="project-dialog-desc">{item.description}</p>}
      </DialogContent>
    </Dialog>
  );
};

export const ParentProjectPhotos = ({ items }) => {
  const { L } = useLang();
  const [open, setOpen] = useState(null);
  if (!items?.length) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5" data-testid="progress-showcase">
      <h3 className="font-bold text-[#0A192F] mb-4 flex items-center gap-2"><Camera className="w-5 h-5 text-[#FF2E63]" />{L("Project photos from class", "कक्षा से प्रोजेक्ट फ़ोटो")}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {items.map((it) => (
          <button key={it.id} onClick={() => setOpen(it)} className="text-left group" data-testid={`progress-showcase-${it.id}`}>
            <div className="aspect-[4/3] rounded-xl overflow-hidden bg-white">
              <img src={photoUrl(it.photos[0])} alt={it.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="mt-2 font-semibold text-sm text-[#0A192F]">{it.title}</div>
            <div className="text-xs text-slate-500">{it.photos.length} {L("photo(s)", "फ़ोटो")} · {new Date(it.created_at).toLocaleDateString("en-IN")}</div>
          </button>
        ))}
      </div>
      <ProjectDialog item={open} onClose={() => setOpen(null)} />
    </div>
  );
};
